import React from "react";
import './AboutSection.css';
import instagramIcon from '../../assets/social-icons/instagram.svg';
import facebookIcon from '../../assets/social-icons/facebook.svg';
import youtubeIcon from '../../assets/social-icons/youtube.svg';
import linkedinIcon from '../../assets/social-icons/linkedin.svg';
import tiktokIcon from '../../assets/social-icons/tiktok.svg';
import websiteIcon from '../../assets/social-icons/website.svg';
import BackgroundDecoration from '../../components/BackgroundDecoration/BackgroundDecoration';

/**
 * AboutSection - Sección "Acerca de" reutilizable
 * Muestra un título principal, tarjetas informativas y opcionalmente información del equipo
 */
const AboutSection = ({ title, cards = [], boton, nosotros, theme = 'dark', backgroundDecoration }) => {
  const socialIconMap = {
    instagram: instagramIcon,
    facebook: facebookIcon,
    youtube: youtubeIcon,
    linkedin: linkedinIcon,
    tiktok: tiktokIcon,
    sitioweb: websiteIcon,
    sitio: websiteIcon,
    web: websiteIcon,
    website: websiteIcon
  };

  const getSocialIcon = (label = '') => {
    const normalized = label
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z]/g, '');

    return socialIconMap[normalized] || websiteIcon;
  };

  const cardElements = cards.map((value, index) => {
    return (
      <div className="cardAbout" key={index}>
        <p className="cardAboutTitle">{value.title.toUpperCase()}</p>
        <p className="cardAboutDescription">{value.description.toUpperCase()}</p>
      </div>
    );
  });

  return (
    <div className={`aboutContainer aboutContainer--${theme}`}>
      {backgroundDecoration && <BackgroundDecoration {...backgroundDecoration} />}
      <p className="aboutMainTitle">{title.toUpperCase()}</p>

      <div className="cardsContainer">
        {cardElements}
      </div>

      {/* Sección de botón (opcional) */}
      {boton && boton.texto && (
        <div className="botonContainer">
          <button
            className={`botonAbout pillButton pillButton--on-${theme}`}
            onClick={() => {
              if (boton.accion) {
                window.location.href = boton.accion;
              }
            }}
          >
            {boton.texto.toUpperCase()}
          </button>
        </div>
      )}

      {/* Sección "Nosotros" (opcional) */}
      {nosotros && nosotros.integrantes && (
        <div className="nosotrosContainer">
          <p className="nosotrosTitle">{nosotros.title.toUpperCase()}</p>
          <div className="integrantesContainer">
            {nosotros.integrantes.map((integrante, index) => (
              <div
                className={`integranteCard ${integrante.isFirst ? 'first' : ''}`}
                key={index}
              >
                <div className="integranteHeader">
                  <img
                    src={integrante.imagen}
                    alt={integrante.nombre}
                    className="integranteImagen"
                  />
                  <div className="integranteMeta">
                    <h3 className={`integranteNombre ${integrante.nombre.length > 14 ? 'integranteNombre--long' : ''}`}>
                      {integrante.nombre}
                    </h3>
                    <h4 className="integranteTitulo">{integrante.titulo}</h4>
                  </div>
                </div>
                <p className="integranteTexto">{integrante.texto}</p>
                <div className="integranteDivider" aria-hidden="true"></div>
                {integrante.redes && (
                  <div className="redesSociales">
                    {integrante.redes.map((red, idx) => (
                      <a
                        href={red.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="redSocial"
                        key={idx}
                        aria-label={red.red}
                      >
                        <img
                          src={getSocialIcon(red.red)}
                          alt={red.red}
                          className="redSocialIcon"
                        />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutSection;
